import GoodsSale from './goods_sale.vue'

export default {
    path: 'goodsSale',
    component: GoodsSale
}
